import { ref } from "vue";
import feldUtils from "@/businesslogic/utils/feldUtils";
import validatoren from "@/businesslogic/validatoren";
import Logger from "js-logger";
import { Anfrage } from "@/model/Anfrage";

export default function formValidierung(): any {
  const formFehler = ref({} as any);
  let formElemente = {} as any;

  const { sucheGewaehltenRadiowert } = feldUtils();

  /*
     Feldvalidierungen
     */

  const {
    checkMinMaxWert,
    checkMinMaxLaenge,
    checkMinMaxDatum,
    checkEmail,
    checkNummer,
    checkTelefonNummer,
    checkMobilNummer,
    checkIban,
    checkMinMaxAlter,
    checkPlz,
  } = validatoren();

  const erzwingeGanzzahl = (event: any) => {
    const nichtNumericPattern = ["e", "E", ".", "+", "-", ","];
    if (nichtNumericPattern.includes(event.key)) {
      event.preventDefault();
    }
  };

  const erzwingeKommazahl = (event: any) => {
    const nichtNumericPattern = ["e", "E", ".", "+", "-"];
    if (nichtNumericPattern.includes(event.key)) {
      event.preventDefault();
    }
  };

  async function validiereErneut(event: any) {
    Logger.trace("validiereErneut: ", event);
    const formElement = event.target;
    formFehler.value[formElement.name] = undefined;
    await validiereElement(formElement);
  }

  function registriereFeldValidierung(formElement: any) {
    formElement.addEventListener("blur", validiereErneut, false);
    if (formElement.type.toLowerCase().indexOf("radio") >= 0) {
      formElement.addEventListener("change", validiereErneut, false);
    }
  }

  function validiereZusammengesetzteNamenLaenge() {
    //Spezialprüfung zusammengesetzte Länge aus Vor- und Nachnamen
    const nameGesamtlaenge = (getFormElementWert("persFirstName") + " " + getFormElementWert("persLastName")).length;
    if (nameGesamtlaenge > 40) {
      formFehler.value["persLastName"] =
        "Vor- und Nachname dürfen zusammen nicht mehr als 40 Zeichen betragen " + "(derzeit " + nameGesamtlaenge + ").";
      scrolleZumErstenFehler();
    }
  }

  function addFehlerMeldung(feldname: string, meldung: string | undefined): void {
    if (meldung) {
      formFehler.value[feldname] = meldung;
    }
  }

  async function validiereElement(formElement: any) {
    const formElementTyp = formElement.type.toLowerCase();
    let formElementWert = formElement.value.trim(); //Achtung! Bei Checkboxen und Radios muss checked ausgewertet werden!

    Logger.trace("==== formElement: " + formElement.name + " ====");
    Logger.trace(
      "formElementTyp: " + formElementTyp,
      "formElementWert: " + formElementWert,
      "elementRequired: " + formElement.required,
      "errorMessage: " + formElement.getAttribute("data-fehlermeldung"),
    );

    if (formElementTyp.indexOf("radio") >= 0) {
      formElementWert = sucheGewaehltenRadiowert(formElement.name);
    } else if (formElementTyp.indexOf("checkbox") >= 0 && !formElement.checked) {
      formElementWert = "";
    }

    Logger.trace("formElementWertNeu: " + formElementWert);

    if (
      formElementTyp.indexOf("radio") >= 0 ||
      formElementTyp.indexOf("checkbox") >= 0 ||
      formElementTyp.indexOf("select") >= 0
    ) {
      // Bei Radio, Checkbox und Select nur prüfen, ob Auswahl getroffen, sofern erforderlich
      if ((formElementWert == "" || formElementWert == "-1") && formElement.required) {
        addFehlerMeldung(formElement.name, "Bitte treffen Sie eine Auswahl.");
      }
    } else {
      // Text, Date, Mail,... auf Wert und Länge prüfen
      if (formElementTyp.indexOf("date") >= 0 || formElement.placeholder == "TT.MM.JJJJ") {
        // Spezielle Min/Max-Prüfung für Datum
        addFehlerMeldung(
          formElement.name,
          checkMinMaxDatum(formElement.name, formElementWert, formElement.min, formElement.max, formElement.required),
        );
      } else if (formElement.min || formElement.max) {
        // Normale Min/Max-Prüfung
        addFehlerMeldung(
          formElement.name,
          checkMinMaxWert(formElement.name, formElementWert, formElement.min, formElement.max, formElement.required),
        );
      }
      if (formElement.minLength || formElement.maxLength) {
        // Längen
        addFehlerMeldung(
          formElement.name,
          checkMinMaxLaenge(
            formElement.name,
            formElementWert,
            formElement.minLength,
            formElement.maxLength,
            formElement.required,
          ),
        );
      }
      if (formElementTyp.indexOf("email") >= 0) {
        // E-Mail
        addFehlerMeldung(formElement.name, checkEmail(formElement.name, formElementWert, formElement.required));
      } else if (formElementTyp.indexOf("number") >= 0 || formElement.getAttribute("data-checknummer")) {
        // Nummer. Vorsicht bei Verwendung von input type="number": Einige Browser erlauben Texteingaben, der
        // dann jedoch einfach verworfen wird (Übermittlung eines leeren Feldwertes). Daher besser mit Attribut.
        addFehlerMeldung(formElement.name, checkNummer(formElement.name, formElementWert, formElement.required));
      } else if (formElement.getAttribute("data-checktelefonnummer")) {
        addFehlerMeldung(formElement.name, checkTelefonNummer(formElement.name, formElementWert, formElement.required));
      } else if (formElement.getAttribute("data-checkmobilnummer")) {
        addFehlerMeldung(formElement.name, checkMobilNummer(formElement.name, formElementWert, formElement.required));
      } else if (formElement.name.toLowerCase().indexOf("iban") >= 0) {
        // IBAN
        addFehlerMeldung(formElement.name, checkIban(formElement.name, formElementWert, formElement.required));
      } else if (formElement.getAttribute("data-checkalter18bis100")) {
        // Alter 18-100
        addFehlerMeldung(formElement.name, checkMinMaxAlter(formElement.name, formElementWert, "", 18, 100));
      } else if (formElement.getAttribute("data-checkplz") && formElement.getAttribute("data-checkplz") !== false) {
        //PLZ

        Logger.debug("data-checkplz", formElement.getAttribute("data-checkplz"));

        const plzCheck: string | undefined = await checkPlz(
          formElement.getAttribute("data-sessionId"),
          formElement.name,
          formElementWert,
          formElement.required,
        );
        addFehlerMeldung(formElement.name, plzCheck);
      }
    }

    // Allgemeine Fehlermeldung mit spezieller überschreiben
    if (formFehler.value[formElement.name] && formElement.getAttribute("data-fehlermeldung")) {
      formFehler.value[formElement.name] = formElement.getAttribute("data-fehlermeldung");
    }
  }

  async function validiereForm(formId = "", scrolleZumFehler = true) {
    formFehler.value = {}; //zurücksetzen

    Logger.trace("----- Starte Formular-Validierung -------");

    formElemente = document.querySelectorAll(
      (formId ? "form#" + formId + " " : "") + "input, " + (formId ? "form#" + formId + " " : "") + "select",
    );

    for (const index in formElemente) {
      const formElement: any = formElemente[index];
      if (typeof formElement == "object") {
        Logger.trace("formElement:", formElement);
        await validiereElement(formElement);
        registriereFeldValidierung(formElement);
      }
    }

    if (scrolleZumFehler) {
      scrolleZumErstenFehler();
    }

    return getFormFehlerAnzahl() > 0;
  }

  function getFormElementWert(name: string) {
    let ergebnis = "";
    formElemente.forEach(function (formElement: any) {
      if (formElement.name == name) {
        ergebnis = formElement.value;
      }
    });
    return ergebnis;
  }

  function getFormFehlerAnzahl() {
    return Object.keys(formFehler.value).length;
  }

  function getFormFehler() {
    return formFehler.value;
  }

  function scrolleZumErstenFehler() {
    if (!getFormFehlerAnzahl()) {
      return; //Kein Fehler > kein Scrolling
    }

    for (const key of Object.keys(formFehler.value)) {
      const formElement = document.querySelector("#" + key + ", input[name='" + key + "'], select[name='" + key + "']");

      if (formElement) {
        Logger.trace("Scrolle zum ersten Fehler: key, formElement: ", key, formElement);

        formElement?.scrollIntoView({ behavior: "smooth" });
      }
      return;
    }
    // Trotz Fehler bislang kein Scrolling zu einem Feld. Dann ab zum Seitenbeginn.
    Logger.debug("Fehler ohne Feld - scrolle zum Seitenbeginn... ");

    document.querySelector("html")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function validiereRabatt(storeData: Anfrage, fehler: any, validiert: boolean): boolean {
    if (storeData.isMakler && getHoechstenMaklerRabatt(storeData)) {
      if (berechneMaxRabatt(storeData) == 0) {
        storeData.tarifinformationen.abschlagZuschlagHoehe = 0;
      }

      delete fehler.value["abschlagZuschlagHoehe"];

      if (validiert && !validMaklerAbschlagZuschlag(storeData)) {
        fehler.value["abschlagZuschlagHoehe"] =
          "Nicht zulässige Rabatthöhe. Gemäß Vereinbarung mit der GEV dürfen Sie maximal " +
          berechneMaxRabatt(storeData) +
          " % Rabatt vergeben.";

        return false;
      }
    }

    return true;
  }

  function validiereVorschaeden(storeData: Anfrage, fehler: any): boolean {
    //-1 = Bitte wählen
    if (storeData.tarifinformationen.vorschaedenAnzahl < 0) {
      fehler.value["vorschaedenAnzahl"] =
        "Bitte wählen Sie in den oben stehenden Tarifoptionen die Anzahl der Vorschäden aus.";
      return false;
    }
    return true;
  }

  function validMaklerAbschlagZuschlag(storeData: Anfrage) {
    if (
      (storeData.isMakler && storeData.tarifinformationen.abschlagZuschlagHoehe < 0) ||
      storeData.tarifinformationen.abschlagZuschlagHoehe > berechneMaxRabatt(storeData)
    ) {
      return false;
    }
    return true;
  }

  function berechneMaxRabatt(storeData: Anfrage) {
    const rabatt = getHoechstenMaklerRabatt(storeData);
    if (rabatt) {
      return rabatt.produktLinien[storeData.preise.produktLinienIndex];
    } else return 0;
  }

  function getHoechstenMaklerRabatt(storeData: Anfrage) {
    const rabatte = storeData.personendaten.vermittler.maklerRabatte;

    if (!rabatte) {
      return null;
    }

    if (rabatte.length === 1) {
      return rabatte[0];
    }

    return rabatte.sort((a, b) => a.allgemein - b.allgemein)[0];
  }

  return {
    validiereForm,
    getFormElementWert,
    getFormFehlerAnzahl,
    getFormFehler,
    validiereErneut,
    scrolleZumErstenFehler,
    validiereRabatt,
    berechneMaxRabatt,
    erzwingeGanzzahl,
    erzwingeKommazahl,
    validMaklerAbschlagZuschlag,
    validiereZusammengesetzteNamenLaenge,
    validiereVorschaeden,
  };
}
